"use client";

import { type ReactNode, createContext, useContext, useRef } from "react";
import type { StoreApi } from "zustand";
import { useStore } from "zustand";
import {
	type MessageReplayStore,
	createMessageReplayStore,
} from "../stores/message-replay";

export const MessageReplayStoreContext =
	createContext<StoreApi<MessageReplayStore> | null>(null);

export interface MessageReplayStoreProviderProps {
	children: ReactNode;
}

export function MessageReplayStoreProvider({
	children,
}: MessageReplayStoreProviderProps): React.ReactElement {
	const storeRef = useRef<StoreApi<MessageReplayStore> | undefined>(undefined);

	if (!storeRef.current) {
		storeRef.current = createMessageReplayStore();
	}

	return (
		<MessageReplayStoreContext.Provider value={storeRef.current}>
			{children}
		</MessageReplayStoreContext.Provider>
	);
}

export function useMessageReplayStore<T>(
	selector: (state: MessageReplayStore) => T,
): T {
	const store = useContext(MessageReplayStoreContext);

	if (!store) {
		throw new Error(
			"useMessageReplayStore must be used within a MessageReplayStoreProvider",
		);
	}

	return useStore(store, selector);
}
